import styled from 'foundations-theming/utils';
export const FiltersWrapper = styled.div.withConfig({
  displayName: "FiltersWrapper"
})(["button[role='combobox']{width:auto;font-weight:600;border:none;background-color:", ";color:", ";&[data-selected-values]{background-color:", ";}}"], ({
  theme
}) => theme.color['fill-transparent-default'], ({
  theme
}) => theme.color['specialty-text-interactive-alt-default'], ({
  theme
}) => theme.color['fill-field-hover']);